import * as React from "react";
import CourseAPI from "./CoursesAPI";
import { DataTable } from "src/components/common";
import { Button } from "src/components/buttons";

import useGetDataHook from "src/admin/Organization/Courses/useGetDataHook";
import {
	StatusFilterMethod,
	filterByStatus,
	setStatusCellValue,
} from "src/components/forms/StatusFilter";
import {
	ClearFilterButton,
	ActionIcon,
} from "src/components/forms/ActionColumnIconsAndButton";
import AuthorizationWrapper from "src/common/AuthorizationWrapper";
import { AdminPermissions } from "src/common/Permissions";
import { Tooltip } from "antd";

interface IProps {
	history?: any;
	location?: any;
	match?: any;
	children?: any;
}

const OrganizationCourses: React.FC = (props: IProps) => {
	const { organizationId, locationId } = props.match.params;

	const [filtered, setFiltered] = React.useState<any>([]);

	const [{ data, isLoading }] = useGetDataHook<CourseWithLocationNameDTO[]>(
		[],
		{
			apiCallFunc: CourseAPI.getLocationCourses,
			params: [{ organizationId, locationId }],
		}
	);

	React.useEffect(() => {
		setFiltered([{ id: "isActive", value: "Active" }]);
	}, []);

	const columns = [
		{
			Header: <Tooltip title="Name">Name</Tooltip>,
			accessor: "name",
		},
		{
			Header: <Tooltip title="Location">Location</Tooltip>,
			accessor: "locationName",
		},
		{
			Header: <Tooltip title="Description">Description</Tooltip>,
			accessor: "description",
		},
		{
			Header: <Tooltip title="Active">Active</Tooltip>,
			accessor: "isActive",
			Cell: setStatusCellValue,
			filterMethod: filterByStatus("isActive"),
			Filter: StatusFilterMethod,
		},
		{
			Header: <Tooltip title="Actions">Actions</Tooltip>,
			Cell: <ActionIcon title="Details" type="open" />,
			Filter: <ClearFilterButton onClick={clearFilters} />,
		},
	];

	return (
		<div className="container-fluid">
			<div className="d-flex mb-4">
				<div className="ml-3">
					<p className="text-danger font-weight-bold">
						IMPORTANT: If this is part of a multi-org configuration, please
						update the other organization(s) accordingly!
					</p>
				</div>
				<div className="ml-auto">
					<AuthorizationWrapper
						type="hide"
						permissions={[AdminPermissions.EditOrganizationLocation]}
					>
						<Button onClick={toNewCoursePage} className="btn btn-primary">
							New Course
						</Button>
					</AuthorizationWrapper>
				</div>
			</div>
			<DataTable
				data={data}
				columns={columns}
				filterable={true}
				filtered={filtered}
				onFilteredChange={onFilterChange}
				onRowClick={onRowClick}
				loading={isLoading}
			/>
		</div>
	);

	// --- Helper Functions --- ///

	function getActionLink(orgId: any, locId: any, rowId: any): string {
		return `/admin/organizations/${orgId}/locations/${locId}/courses/${rowId}`;
	}

	function onRowClick({ row }: { row?: any }) {
		props.history.push(
			getActionLink(organizationId, locationId, row._original.id)
		);
	}

	function clearFilters(): void {
		setFiltered([{ id: "isActive", value: "Active" }]);
	}

	function onFilterChange(newFilter: any): void {
		setFiltered(newFilter);
	}

	function toNewCoursePage() {
		props.history.push({
			pathname: `/admin/organizations/${organizationId}/locations/${locationId}/courses/-1`,
		});
	}
};

export default OrganizationCourses;
